import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { NotificationService } from '@upr-web-primer/notification';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonUtilityService } from './common-utility.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  pageLabels: any;
  errorMessage: any;
  constructor(
    private readonly notificationService: NotificationService,
    private readonly injector: Injector,
    @Inject('GlobalDefaults') public globalDefault: any,
  ) {}

  intercept(req: any, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const commonUtilityService = this.injector.get(CommonUtilityService);
        if (req?.url?.includes(`/states`) && error?.status === 0) {
          commonUtilityService.loadMockPrefectureData();
        }
        if (
          req?.url?.includes(`users/current/carts`) ||
          req?.url?.includes(`users/current/carts/current`)
        ) {
          this.errorMessage = '';
          this.notificationService.hide();
        } else if (
          error?.status === this.globalDefault?.ERROR_503 ||
          error?.status === this.globalDefault?.ERROR_500
        ) {
          this.pageLabels = commonUtilityService.getResolvedPageData();
          this.errorMessage = this.pageLabels?.['errCode.COMM.503'];
          this.notificationService.show(this.errorMessage);
          this.errorMessage = '';
        }
        if (this.errorMessage) {
          throwError(() => this.errorMessage);
        }
        return throwError(error);
      }),
    );
  }
}
